export const SUBSCRIPTION_CENTER_GROUPS = [
  {
    id: 1,
    groupName: 'ACMF_REPORT',
    roles: [{ AcmfUser: [17] }],
    visible: true,
  },
  {
    id: 2,
    groupName: 'MX_REC',
    roles: [
      { IssueInvestigator: [3, 19, 20, 22] },
      { IssueUpdater: [19, 22] },
      { IssueInvestigationReader: [3, 19, 20, 22] },
    ],
    visible: true,
  },
  {
    id: 16,
    groupName: 'ACMF_ANALYTIC_ALERT',
    roles: [{ AcmfUser: [16] }],
    visible: true,
  },
]
export const getPWCUserReportTypeIDS = [
  '201',
  '202',
  '203',
  '013',
  '014',
  '016',
  '017',
]

export const getSubscriptionDetails = async (
  groupName,
  isSingleAirlineUser = false,
  roles = [],
) => {
  let subscriptionDetails = {
    pageTitle: '',
    surfaceTitle: '',
    description: '',
    notifications: {
      description: '',
      options: [],
    },
    groups: [],
  }

  switch (groupName) {
    case 'acmf-report':
      subscriptionDetails = {
        pageTitle: 'ACMF Report',
        surfaceTitle: 'Set ACMF Report Subscription Criteria',
        description: isSingleAirlineUser
          ? 'Set notifications for when ACMF reports are received for my fleet. Filter notifications by ACMF report type.'
          : 'Set notifications for when ACMF reports are received for my fleet. Filter notifications by airline or ACMF report type.',
        filterOptions: [
          {
            label: 'airline',
            selectionLabel: 'Report(s)',
            singleSelectionLabel: 'ACMF Report Type(s)',
            value: 0,
            checked: true,
          },
          {
            label: 'ACMF report type',
            selectionLabel: 'Airline(s)',
            value: 1,
            groups: [
              {
                name: 'Event Reports',
                value: 0,
                isPerformanceReport: false,
              },
              {
                name: 'Performance Reports',
                value: 1,
                isPerformanceReport: true,
              },
            ],
          },
        ],
        notifications: roles.includes('AcmfUser')
          ? [
              {
                emailTypeId: 17,
                label: '',
                visible: false,
                isEnabled: true,
              },
            ]
          : [],
      }
      break
    case 'acmf-analytic-alert':
      subscriptionDetails = {
        pageTitle: 'ACMF ANALYTIC ALERT',
        surfaceTitle: 'SET ACMF ANALYTIC ALERT SUBSCRIPTION CRITERIA',
        description: isSingleAirlineUser
          ? 'Set notifications for when an ACMF analytic alerts on select report types. Note: reports list includes only those with associated ACMF analytics.'
          : 'Set notifications for when an ACMF analytic alerts on select report types. Filter notifications by airline or ACMF report type to make selections. Note: reports list includes only those with associated ACMF analytics.',
        filterOptions: [
          {
            label: 'airline',
            selectionLabel: 'Report(s)',
            singleSelectionLabel: 'ACMF Report Type(s)',
            value: 0,
            checked: true,
          },
          {
            label: 'ACMF report type',
            selectionLabel: 'Airline(s)',
            value: 1,
            groups: [
              {
                name: 'Event Reports',
                value: 0,
                isPerformanceReport: false,
              },
              {
                name: 'Performance Reports',
                value: 1,
                isPerformanceReport: true,
              },
            ],
          },
        ],
        notifications: roles.includes('AcmfUser')
          ? [
              {
                emailTypeId: 16,
                label: '',
                visible: false,
                isEnabled: true,
              },
            ]
          : [],
      }
      break
    case 'maintenance':
      subscriptionDetails = {
        pageTitle: 'Maintenance',
        surfaceTitle: 'Set Maintenance Subscription Criteria',
        description: roles.includes('IssueUpdater')
          ? isSingleAirlineUser
            ? 'Set notifications for maintenance recommendations for my fleet. First, filter notifications by ATA chapter. Then select further criteria.'
            : 'Set notifications for maintenance recommendations for my fleet. First, filter notifications by airline or ATA chapter, Then select further criteria.'
          : isSingleAirlineUser
          ? 'Set notifications for maintenance alerts for my fleet. First, filter notifications by ATA chapter. Then select further criteria.'
          : 'Set notifications for maintenance alerts for my fleet. First, filter notifications by airline or ATA chapter, Then select further criteria.',
        filterOptions: [
          {
            label: 'airline',
            selectionLabel: 'ATA Chapters',
            singleSelectionLabel: 'ATA Chapters',
            value: 0,
            checked: true,
          },
          {
            label: 'ATA chapter',
            selectionLabel: 'Airline(s)',
            value: 1,
          },
        ],
        notifications: roles.includes('AirlineUser')
          ? roles.includes('IssueUpdater')
            ? [
                {
                  emailTypeId: 19,
                  label: 'A new maintenance recommendation is available.',
                },
                {
                  emailTypeId: 22,
                  label: 'A maintenance recommendation is completed.',
                },
              ]
            : roles.includes('IssueInvestigator') ||
              roles.includes('IssueInvestigationReader')
            ? [
                {
                  emailTypeId: 3,
                  label: 'A new maintenance alert has been created.',
                },
                {
                  emailTypeId: 19,
                  label: 'A maintenance recommendation is submitted.',
                },
                {
                  emailTypeId: 20,
                  label: 'Maintenance Action Follow-up section is updated.',
                },
                {
                  emailTypeId: 22,
                  label: 'A maintenance recommendation is completed.',
                },
              ]
            : []
          : roles.includes('AcmfUser')
          ? [
              {
                emailTypeId: 19,
                label: 'A new maintenance recommendation is available.',
              },
              {
                emailTypeId: 22,
                label: 'A maintenance recommendation is completed.',
              },
            ]
          : [],
      }
      break
    default:
  }

  return subscriptionDetails
}

export const buildAirlinesToReportTypeItems = (
  reportTypes,
  airlinesWithMasterModels,
  currentSelections = [],
  groups = [],
) => {
  const mappedItems = airlinesWithMasterModels.map(
    ({
      text,
      items,
      checked = false,
      indeterminate = undefined,
      expanded = false,
      airlineIcaoCode,
    }) => {
      const reportItems = []

      items.forEach(airlineMasterModelObj => {
        const masterModelId = airlineMasterModelObj.masterModelId

        reportTypes.forEach(reportObj => {
          const gidx = groups.findIndex(
            group =>
              group.isPerformanceReport === reportObj.isPerformanceReport,
          )
          if (reportObj.masterModelId === masterModelId) {
            let itemChecked = false
            if (currentSelections && currentSelections.length) {
              itemChecked =
                currentSelections.findIndex(
                  selection =>
                    selection.IcaoCode === airlineIcaoCode &&
                    selection.ReportNumbers.includes(reportObj.reportNumber),
                ) > -1
            }

            reportItems.push({
              text: reportObj.displayName,
              value: reportObj.reportNumber,
              checked: itemChecked,
              group: groups[gidx].value,
              groupName: groups[gidx].name,
            })
          }
        })
      })

      if (reportItems.length > 0) {
        if (currentSelections && currentSelections.length) {
          const checkedItems = reportItems.filter(item => item.checked)
          if (checkedItems.length) {
            if (checkedItems.length === reportItems.length) {
              checked = true
            } else {
              checked = false
              indeterminate = true
            }
          }
        }

        return {
          text: text,
          value: airlineIcaoCode,
          items: reportItems,
          checked: checked,
          indeterminate: indeterminate,
          expanded: expanded,
        }
      } else {
        return null
      }
    },
  )

  const filteredMappedItems = mappedItems.filter(
    item => item && item.items && item.items.length,
  )

  return filteredMappedItems
}

export const buildReportTypesToAirlineItems = (
  airlinesWithMasterModels,
  reportTypes,
  currentSelections = [],
  groups = [],
) => {
  const mappedItems = reportTypes.map(
    ({
      displayName,
      reportNumber,
      masterModelId,
      isPerformanceReport,
      checked = false,
      indeterminate = undefined,
      expanded = false,
    }) => {
      const items = []

      airlinesWithMasterModels.forEach(airlineObj => {
        const masterModels = airlineObj.items.filter(airlineItem => {
          return airlineItem.masterModelId === masterModelId
        })

        if (masterModels.length) {
          let itemChecked = false
          if (currentSelections && currentSelections.length) {
            itemChecked =
              currentSelections.findIndex(
                selection =>
                  selection.IcaoCode === airlineObj.airlineIcaoCode &&
                  selection.ReportNumbers.includes(reportNumber),
              ) > -1
          }

          items.push({
            ...airlineObj,
            checked: itemChecked,
          })
        }
      })

      if (currentSelections && currentSelections.length) {
        const checkedItems = items.filter(item => item.checked)
        if (checkedItems.length) {
          if (checkedItems.length === items.length) {
            checked = true
          } else {
            checked = false
            indeterminate = true
          }
        }
      }

      const gidx = groups.findIndex(
        group => group.isPerformanceReport === isPerformanceReport,
      )

      return {
        text: displayName,
        value: reportNumber,
        items: items,
        checked: checked || false,
        expanded: expanded || false,
        indeterminate: indeterminate,
        group: groups[gidx].value,
        groupName: groups[gidx].name,
      }
    },
  )

  const filteredMappedItems = mappedItems.filter(
    item => item.items && item.items.length,
  )
  return filteredMappedItems
}

export const buildAirlinesToAtaChapterItems = (
  airlines,
  ataChapters,
  currentSelections = [],
) => {
  // value: 0 / Filter by Airline / default
  return (
    airlines.map(
      ({
        text,
        value,
        items,
        checked = false,
        indeterminate = undefined,
        expanded = false,
        airlineIcaoCode,
      }) => {
        if (currentSelections && currentSelections.length) {
          let checkedItems = 0
          items.forEach(system => {
            let itemChecked = false
            itemChecked =
              currentSelections.findIndex(
                selection =>
                  selection.IcaoCode === airlineIcaoCode &&
                  selection.AtaChapters.includes(system.value),
              ) > -1

            if (itemChecked) checkedItems++
            system.checked = itemChecked
          })

          if (checkedItems) {
            if (checkedItems === items.length) {
              checked = true
            } else {
              checked = false
              indeterminate = true
            }
          }
        }

        return {
          text,
          value,
          items,
          checked,
          indeterminate,
          expanded,
        }
      },
    ) || []
  )
}

export const buildAtachaptersToAirlineItems = (
  ataChapters,
  airlines,
  currentSelections = [],
) => {
  // value: 1 / Filter by ataChapters
  return (
    ataChapters.map(
      ({
        text,
        value,
        items,
        checked = false,
        indeterminate = undefined,
        expanded = false,
      }) => {
        if (currentSelections && currentSelections.length) {
          let checkedItems = 0
          items.forEach(airline => {
            let itemChecked = false
            itemChecked =
              currentSelections.findIndex(
                selection =>
                  selection.IcaoCode === airline.airlineIcaoCode &&
                  selection.AtaChapters.includes(value),
              ) > -1

            if (itemChecked) checkedItems++
            airline.checked = itemChecked
          })

          if (checkedItems) {
            if (checkedItems === items.length) {
              checked = true
            } else {
              checked = false
              indeterminate = true
            }
          }
        }

        return {
          text,
          value,
          items,
          checked,
          indeterminate,
          expanded,
        }
      },
    ) || []
  )
}

const getCheckedOptionsWithItems = selections => {
  const selectedOptions = selections.filter(
    options => options.checked || options.indeterminate,
  )

  selectedOptions.forEach(option => {
    option.items = option.items.filter(item => item.checked)
  })

  return selectedOptions
}

const parentToItems = (
  selections,
  parentId = 'parentId',
  itemIds = 'itemIds',
) => {
  const results = []
  selections.forEach(option => {
    option.items.forEach(item => {
      const parentIndex = results.find(
        option => option[parentId] === option.value,
      )
      if (parentIndex > -1) {
        results[parentIndex][itemIds].push(item.value)
      } else {
        results.push({
          [parentId]: option.value,
          [itemIds]: [item.value],
        })
      }
    })
  })
  return results
}

const itemsToParent = (
  selections,
  parentId = 'parentId',
  itemIds = 'itemIds',
) => {
  const results = []
  selections.forEach(option => {
    option.items.forEach(item => {
      const parentIndex = results.findIndex(option => {
        return option[parentId] === item.airlineIcaoCode
      })

      if (parentIndex > -1) {
        // Already parent exists then update the items
        results[parentIndex][itemIds].push(option.value)
      } else {
        // Insert New objwith parent and Item
        results.push({
          [parentId]: item.airlineIcaoCode,
          [itemIds]: [option.value],
        })
      }
    })
  })
  return results
}

export const getSelections = (groupName, selectedFilter, selections) => {
  if (selections && selections.length && selectedFilter) {
    const selectedOptionsWithItems = getCheckedOptionsWithItems(selections)
    if (selectedOptionsWithItems && selectedOptionsWithItems.length) {
      // check to see if NO items are selectee and if so just
      // return an empty array
      const areThereSelections = selections.filter(selection => {
        return selection.items.length
      })
      if (!areThereSelections.length) {
        return []
      }
      switch (groupName) {
        case 'acmf-report': {
          if (selectedFilter.value === 0) {
            // Airline to reportNumbers as items
            return parentToItems(
              selectedOptionsWithItems,
              'IcaoCode',
              'ReportNumbers',
            )
          } else if (selectedFilter.value === 1) {
            // ReportNumbers to airline as items
            return itemsToParent(
              selectedOptionsWithItems,
              'IcaoCode',
              'ReportNumbers',
            )
          }
          break
        }
        case 'acmf-analytic-alert': {
          if (selectedFilter.value === 0) {
            // Airline to reportNumbers as items
            return parentToItems(
              selectedOptionsWithItems,
              'IcaoCode',
              'ReportNumbers',
            )
          } else if (selectedFilter.value === 1) {
            // ReportNumbers to airline as items
            return itemsToParent(
              selectedOptionsWithItems,
              'IcaoCode',
              'ReportNumbers',
            )
          }
          break
        }
        case 'maintenance': {
          if (selectedFilter.value === 0) {
            // Airline to system as items
            return parentToItems(
              selectedOptionsWithItems,
              'IcaoCode',
              'AtaChapters',
            )
          } else if (selectedFilter.value === 1) {
            // System to airline as items
            return itemsToParent(
              selectedOptionsWithItems,
              'IcaoCode',
              'AtaChapters',
            )
          }
          break
        }
        default:
          break
      }
    }
  }
  return []
}
